import type {operations} from "~/types/api-types";
import {apiAuthFetcher, apiFetcher} from "~/lib/fetchers";

export type SubscriberSearchResponse = operations["getSubscribers"]["responses"]["200"]["content"]["application/cz.trieu.zmrzlina2ad-v1+json"];

export async function getSubscribers(): Promise<SubscriberSearchResponse> {
  return apiFetcher<SubscriberSearchResponse>("/public/subscriber", {
    method: "GET",
  })
}

export type SubscriberPatchRequest = operations["updateSubscriber"]["requestBody"]["content"]["application/json"]
export async function patchSubscriber(id: string, request: SubscriberPatchRequest) {
  return apiAuthFetcher(`/admin/subscriber/${id}`, {
    method: "PATCH",
    body: {
      ...request
    }
  })
}

export type SubscriberCreateRequest = operations["createSubscriber"]["requestBody"]["content"]["application/json"]
export async function createSubscriber(request: SubscriberCreateRequest) {
  return apiAuthFetcher("/admin/subscriber", {
    method: "POST",
    body: {
      ...request
    }
  })
}

export type AdminSubscriberSearchQuery = operations["searchSubscriberAdmin"]["parameters"]["query"]
export type AdminSubscriberSearchResponse = operations["searchSubscriberAdmin"]["responses"]["200"]["content"]["application/cz.trieu.zmrzlina2ad-v1+json"];
export async function searchAdminSubscribers(query: AdminSubscriberSearchQuery) {
  return apiAuthFetcher<AdminSubscriberSearchResponse>("/admin/subscriber/search", {
    method: "POST",
    params: {
      ...query
    },
  })
}


export async function deleteAdminSubscriber(id: string) {
  return apiAuthFetcher(`/admin/subscriber/${id}`, {
    method: "DELETE",
  })
}
